import type { OrganizationAlert } from '@/shared/hooks/api/regulatoryNews'
import { NewsroomAlertListItem } from './NewsroomAlertListItem'

type NewsroomAlertListProps = {
  alerts: OrganizationAlert[]
  selectedAlertId: string | null
  onSelectAlert: (alertId: string) => void
}

export function NewsroomAlertList({
  alerts,
  selectedAlertId,
  onSelectAlert,
}: NewsroomAlertListProps) {
  return (
    <ul className='space-y-2 border-r p-2'>
      {alerts.map((alert) => (
        <NewsroomAlertListItem
          key={alert.id}
          alert={alert}
          isSelected={alert.id === selectedAlertId}
          onSelect={onSelectAlert}
        />
      ))}
    </ul>
  )
}
